import script from "./PrescriptionComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PrescriptionComponent.vue?vue&type=script&setup=true&lang=js"

import "./PrescriptionComponent.vue?vue&type=style&index=0&id=0e794514&lang=css"

const __exports__ = script;

export default __exports__